import { render } from "./OrderImport.vue?vue&type=template&id=e0a6bc5a&scoped=true"
import script from "./OrderImport.vue?vue&type=script&lang=js"
export * from "./OrderImport.vue?vue&type=script&lang=js"

import "./OrderImport.vue?vue&type=style&index=0&id=e0a6bc5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0a6bc5a"]])

export default __exports__